import React from 'react';
import { GenericOverlayError } from '../../../fallback-screens/components/overlay-errors/OverlayErrors';
import styles from '../../../fallback-screens/components/overlay-errors/OverlayErrors.module.scss';

export function UserRbacAccessError({
  isTransformationView = false
}: {
  isTransformationView?: boolean;
}) {
  return (
    <GenericOverlayError
      title='You do not have permissions to perform the data query.😢'
      description='Please contact your administrator to request access'
      descriptionClassName={isTransformationView ? 'mx-6' : ''}
    />
  );
}
